import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

import { dateRangeZodObject } from "@@/shared/date-time/date-range";
import { idZodSchema } from "@@/shared/id";
import { contactInfoZodObject } from "@@/shared/locations/contact-info";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { quoteIdZodSchema } from "@@/shared/quotes/quote-id";
import { translatableZodSchema } from "@@/shared/translations/translation";

const duplicateQuoteCommandZodSchema = z.object({
    _id: idZodSchema,
    _type: z.literal("DUPLICATE_QUOTE_COMMAND"),
    quoteId: quoteIdZodSchema,
    providerId: providerIdZodSchema,

    quoteName: translatableZodSchema,
    customer: contactInfoZodObject,

    dateRange: dateRangeZodObject,

    notes: z.string().optional(),
});

type DuplicateQuoteCommand = z.infer<typeof duplicateQuoteCommandZodSchema>;

const duplicateQuoteCommandFactoryParamsZodObject =
    duplicateQuoteCommandZodSchema.omit({
        _id: true,
        _type: true,
    });

type DuplicateQuoteCommandFactoryParams = z.infer<
    typeof duplicateQuoteCommandFactoryParamsZodObject
>;

const duplicateQuoteCommandFactory = (
    params: DuplicateQuoteCommandFactoryParams,
): DuplicateQuoteCommand => {
    return {
        ...params,
        _id: generateId("DUPLICATE_QUOTE_COMMAND__"),
        _type: "DUPLICATE_QUOTE_COMMAND",
    };
};

export {
    duplicateQuoteCommandFactory,
    duplicateQuoteCommandFactoryParamsZodObject,
    duplicateQuoteCommandZodSchema,
};

export type { DuplicateQuoteCommand, DuplicateQuoteCommandFactoryParams };
